export type Step = "carriers" | "coverages" | "review";

/** Named step identifiers for type-safe comparisons */
export const STEP_CARRIERS: Step = "carriers";
export const STEP_COVERAGES: Step = "coverages";
export const STEP_REVIEW: Step = "review";

export interface StepState {
  currentStep: Step;
  selectedCarriers: string[];
  selectedCoverages: string[];
  isOfflineSubmission: boolean;
}

export const STEP_ORDER: Step[] = [STEP_CARRIERS, STEP_COVERAGES, STEP_REVIEW];

export const getNextStep = (currentStep: Step): Step | null => {
  const currentIndex = STEP_ORDER.indexOf(currentStep);
  if (currentIndex < STEP_ORDER.length - 1) {
    return STEP_ORDER[currentIndex + 1];
  }
  return null;
};

export const getPreviousStep = (currentStep: Step): Step | null => {
  const currentIndex = STEP_ORDER.indexOf(currentStep);
  if (currentIndex > 0) {
    return STEP_ORDER[currentIndex - 1];
  }
  return null;
};

export const isFirstStep = (step: Step): boolean => step === STEP_ORDER[0];
export const isLastStep = (step: Step): boolean =>
  step === STEP_ORDER[STEP_ORDER.length - 1];

export const initialStepState: StepState = {
  currentStep: STEP_CARRIERS,
  selectedCarriers: [],
  selectedCoverages: [],
  isOfflineSubmission: false,
};
